// extracted by mini-css-extract-plugin
module.exports = {"Overview":"Overview_Overview__2IwWo"};